import {PlatformCharacterLimit} from './types';

export const PLATFORM_FORMAT_MAP: Partial<Record<string, PlatformCharacterLimit>> = {
  sauto: {format: 'plainText', characterLimit: 1000},
  'mobile.de': {format: 'mobileDe', characterLimit: 5000},
  autoscout24: {format: 'autoScout24', characterLimit: null},
  otomoto: {format: 'html', characterLimit: 4000},
  autocaris: {format: 'plainText', characterLimit: 4000},
  tipcars: {format: 'plainText', characterLimit: null},
  olx: {format: 'plainText', characterLimit: null},
  myweb: {format: 'plainText', characterLimit: null},
  'skoda-plus': {format: 'plainText', characterLimit: null},
  'das-weltauto': {format: 'plainText', characterLimit: null},
  'mercedes-benz': {format: 'plainText', characterLimit: null},
  'hyundai-promise': {format: 'plainText', characterLimit: null},
  'ford-uzivane': {format: 'plainText', characterLimit: null},
  'autoplac.pl': {format: 'plainText', characterLimit: null},
  vehis: {format: 'plainText', characterLimit: null},
  'bnp-paribas-mamgo': {format: 'plainText', characterLimit: null},
  'ford-geronimo': {format: 'plainText', characterLimit: null},
  'samochody.pl': {format: 'plainText', characterLimit: null},
  findcar: {format: 'plainText', characterLimit: null},
  'fastback-trade': {format: 'plainText', characterLimit: null},
  'fastback-inter-dealer': {format: 'plainText', characterLimit: null},
  community: {format: 'plainText', characterLimit: null},
};

export const DEFAULT_PLATFORM_FORMAT: PlatformCharacterLimit = {
  format: 'plainText',
  characterLimit: null,
};
